// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__RFicZ","tab":"Dropdown_tab__KW0UN","dropdownItems":"Dropdown_dropdownItems__9jSyW","item":"Dropdown_item__uHc8w"};